import { SnackbarOptions } from '@new-components/elements/snackbar/types';

export const NO_PIN_ERROR = 'ERROR-NO_PIN';

export const SERVER_ERROR: SnackbarOptions = {
  title: 'Maaf, GrabModal Sedang Maintenance',
  message:
    'Cek berkala untuk tau apakah maintenance sudah selesai atau belum, ya.',
  severity: 'error',
};
